import type { DebugOptions } from "./debug";
import { CalcClient } from "./client";

import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(timezone);
dayjs.extend(utc);

export type { TCellEdit } from "./client";

type CalcClientOptions = {
  isSharedWorker: boolean;
  debug: DebugOptions;
};

// Format the date as YYYY-MM-DD, and use it as a query parameter to force the browser to create a new worker instance each day on refresh.
export const sharedWorkerDate = dayjs().tz("Europe/London").format("YYYY-MM-DD");

export const createCalcClient = (options: CalcClientOptions) =>
  new CalcClient(() => {
    if (options.isSharedWorker && typeof SharedWorker !== "undefined") {
      return new SharedWorker(new URL("../lib/worker.ts", import.meta.url), {
        type: "module",
        name: "worker-calcs",
      });
    } else {
      return new Worker(new URL("../lib/worker.ts", import.meta.url), {
        type: "module",
        name: "worker-calcs",
      });
    }
  });
